import { render, staticRenderFns } from "./InsuranceProviders.vue?vue&type=template&id=c430a8ba"
import script from "./InsuranceProviders.vue?vue&type=script&lang=js"
export * from "./InsuranceProviders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports